module.exports = __webpack_public_path__ + "static/media/avatar.85fb0cb5.jpg";